export const BLOCKS = [
  {
    title: "Command Team",
    slots: [
      "Incident Command",
      "Unified Command",
      "Planning",
      "Logistics",
      "Ops Manager",
    ],
  },

  { title: "Dispatch", slots: ["Dispatcher", "Dispatcher 2"] },

  {
    title: "Medical HQ",
    slots: [
      "Triage Supervisor",

      // Physicians (2)
      "Physician__1",
      "Physician__2",

      // RN (2)
      "RN__1",
      "RN__2",

      // APRN/PA (2)
      "APRN/PA__1",
      "APRN/PA__2",

      // Paramedic (3)
      "Paramedic__1",
      "Paramedic__2",
      "Paramedic__3",

      // EMT/AEMT (3)
      "EMT/AEMT__1",
      "EMT/AEMT__2",
      "EMT/AEMT__3",

      "Tech",
      "Transport",

      // Ambulance (2)
      "Ambulance (ALS)__1",
      "Ambulance (ALS)__2",
    ],
  },

  {
    title: "Front 9",
    slots: [
      "Ops Supervisor 1",

      // Tent 3 (4 slots)
      "Tent 3__1",
      "Tent 3__2",
      "Tent 3__3",
      "Tent 3__4",

      "Cart 3",

      // Tent 5
      "Tent 5__1",
      "Tent 5__2",
      "Tent 5__3",
      "Tent 5__4",

      "Cart 5",

      // Tent 9
      "Tent 9__1",
      "Tent 9__2",
      "Tent 9__3",
      "Tent 9__4",

      "Cart 9",
      "Bike 1",
    ],
  },

  {
    title: "Back 9",
    slots: [
      "Ops Supervisor 2",

      // Tent 12
      "Tent 12__1",
      "Tent 12__2",
      "Tent 12__3",
      "Tent 12__4",

      "Cart 12",
      "Cart 15",

      // Tent 17
      "Tent 17__1",
      "Tent 17__2",
      "Tent 17__3",
      "Tent 17__4",

      "Cart 17",
      "Bike 2",
      "Bike 3",
    ],
  },
];

export const EXTRA_POSITION_OPTIONS = [
  "Incident Command",
  "Unified Command",
  "Planning",
  "Logistics",
  "Ops Manager",
  "Supervisor",
  "Dispatcher",
  "Transport",
  "Physician",
  "APRN/PA",
  "RN",
  "Paramedic",
  "AEMT",
  "EMT",
  "EMR",
  "Tech",
  "Student",
  "Resident",
  "Ambulance (ALS)",
  "Ambulance (BLS)",
];